import React from 'react'
import {Link} from "react-router-dom"
import Main from './Main'
import image from "./assets/img/BARUN.jpg"

function About() {
    return (
        <>
           <Main active="about">
               <div className="main">
                    <section id="about" className="about">
                        <div className="container">

                            <div className="section-title">
                            <h2>About</h2>
                            <p style={{fontSize : "1rem"}}>Experienced Software Engineer with a demonstrated history of working in the information technology and services industry. Skilled in node js, Express, RDBMS, NoSQL with highly efficient learning ability. Front end development experience with JavaScript (ES6), HTML, CSS,React etc.
                            </p>
                            </div>

                            <div className="row">
                                <div className="col-lg-3" style={{"textAlign":"center"}}>
                                    <img src={image} className="img-fluid img-profile" alt=""/>
                                </div>
                                <div className="col-lg-9 pt-4 pt-lg-0 content">
                                    <h3>Full Stack Developer.</h3>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <ul>
                                            <li><i className="bx bx-chevron-right"></i> <strong>Birthday :</strong> 19 Oct 1994</li>
                                            <li><i className="bx bx-chevron-right"></i> <strong>Phone :</strong>7872635015</li>
                                            <li><i className="bx bx-chevron-right"></i> <strong>City :</strong> Asansol</li>
                                            <li><i className="bx bx-chevron-right"></i> <strong>State :</strong> West Bengal</li>
                                            </ul>
                                        </div>
                                        <div className="col-lg-6">
                                            <ul>
                                            <li><i className="bx bx-chevron-right"></i> <strong>Age :</strong> 27</li>
                                            <li><i className="bx bx-chevron-right"></i> <strong>Degree :</strong> B.Tech (Information Technology)</li>
                                            <li><i className="bx bx-chevron-right"></i> <strong>Email :</strong> barunpandey402@gmail.com</li>
                                            <li><i className="bx bx-chevron-right"></i> <strong>Country :</strong> India</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h3>Education</h3>
                                            <div className="row">
                                                <div className="col-12">
                                                <ul>
                                                     <li><i className="bx bx-chevron-right"></i> <strong>Institute :</strong> Asansol Engineering Collage</li>
                                                     <li><i className="bx bx-chevron-right"></i> <strong>Grade :</strong> 8.67</li>
                                                 </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h3>Language</h3>
                                            <div className="row">
                                                <div className="col-12">
                                                <ul>
                                                     <li><i className="bx bx-chevron-right"></i> English</li>
                                                     <li><i className="bx bx-chevron-right"></i> Hindi</li>
                                                 </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <p>Know more about my <Link to="/skills">Skills</Link> and <Link to="/resume">experience</Link></p>
                                </div>
                            </div>
                            
                            <hr style={{"borderTop": "2px solid rgba(0,0,0,.1)"}}></hr>
                            <div style={{"textAlign":"center"}}>
                                <span className="about-icon-div"><i className="bx bxl-github about-icon"></i>github.com/BarunPandey402</span>
                                <span className="about-icon-div"><i className="bx bxl-twitter about-icon"></i>@BarunKu63177728</span>
                                <span className="about-icon-div"><i className="bx bxl-linkedin about-icon"></i>linkedin.com/in/barun-kumar-pandey</span>
                            </div>
                        </div>
                    </section>
                </div>
            </Main> 
        </>
    )
}

export default About
